import { createAction, props } from '@ngrx/store';
import { IProcessPartnersState } from './process-partners.state';
import {
  ICreateProcessPartner,
  IProcessPartners,
  IProcessPartnersResponse,
} from '../process-partners.models';
import { IPpSpSearch } from '../../users/users.models';

export const loadProcessPartners = createAction(
  '[ProcessPartners] Load Process Partners'
);
export const loadProcessPartnersSuccess = createAction(
  '[ProcessPartners] Load Process Partners Success',
  props<IProcessPartnersState>()
);
export const loadProcessPartnersFailure = createAction(
  '[ProcessPartners] Load Process Partners Failure',
  props<{
    error: unknown;
    loading: boolean;
  }>()
);

export const setProcessPartnerInactive = createAction(
  '[ProcessPartners] Set Process Partner Inactive',
  props<{ processPartners: Partial<IProcessPartners>[] }>()
);
export const setProcessPartnerInactiveSuccess = createAction(
  '[ProcessPartners] Set Process Partner Inactive Success'
);

export const searchProcessPartners = createAction(
  '[ProcessPartners] Search Process Partners',
  props<{ searchObj: IPpSpSearch; loading: boolean }>()
);

export const searchProcessPartnersSuccess = createAction(
  '[ProcessPartners] Search Process Partners Success',
  props<IProcessPartnersState>()
);

export const searchProcessPartnersFailure = createAction(
  '[ProcessPartners] Search Process Partners Failure',
  props<{
    error: unknown;
    loading: boolean;
  }>()
);

export const loadProcessPartnerById = createAction(
  '[ProcessPartners] Get Process Partner By Id',
  props<{ id: number }>()
);
export const loadProcessPartnerByIdSuccess = createAction(
  '[ProcessPartners] Get Process Partner By Id Success',
  props<{ processPartner: IProcessPartnersResponse }>()
);
export const loadProcessPartnerByIdFailure = createAction(
  '[ProcessPartners] Get Process Partner By Id Failure',
  props<{ error: unknown }>()
);

export const createProcessPartner = createAction(
  '[ProcessPartners] Create Process Partner',
  props<{ processPartner: ICreateProcessPartner }>()
);
export const createProcessPartnerSuccess = createAction(
  '[ProcessPartners] Create Process Partner Success',
  props<{ processPartner: IProcessPartnersResponse }>()
);
export const createProcessPartnerFailure = createAction(
  '[ProcessPartners] Create Process Partner Failure'
);

export const updateProcessPartner = createAction(
  '[ProcessPartners] Update Process Partner',
  props<{ id: number; processPartner: IProcessPartnersResponse }>()
);
export const updateProcessPartnerSuccess = createAction(
  '[ProcessPartners] Update Process Partner Success',
  props<{ processPartner: IProcessPartnersResponse }>()
);
export const updateProcessPartnerFailure = createAction(
  '[ProcessPartners] Update Process Partner Failure'
);
